module.exports = __webpack_public_path__ + "img/full4-min.c514ed14.png";